import axios from "axios";

export const apiUrl = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});